import dedent from 'ts-dedent'
import { ColumnDataType, Provider, WorkflowComponentParamType, WorkflowComponentCodeParams } from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

class PolyBuild extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'alteryx.polybuild',
        group: 'Data Preparation',
        title: 'Poly Build',
        description: `
                    This component takes a group of spatial point objects and draws a polygon or polyline
                    in a specific order to represent that group of points.
                    `,
        tags: ['alteryx']
      },
      [
        {
          name: 'buildmethod',
          type: WorkflowComponentParamType.Selection,
          title: 'Build Method',
          options: ['Convex Hull', 'Sequence Polygon', 'Sequence Polyline'],
          default: 'Sequence Polygon'
        },
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'sourcefield',
          type: WorkflowComponentParamType.Column,
          title: 'Source Field',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        },
        {
          name: 'groupfield',
          type: WorkflowComponentParamType.Column,
          title: 'Group Field',
          parent: 'source',
          dataType: [ColumnDataType.String, ColumnDataType.Number]
        },
        {
          name: 'sequencefield',
          type: WorkflowComponentParamType.Column,
          title: 'Sequence Field',
          parent: 'source',
          dataType: [ColumnDataType.Number]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    if (connection.type !== Provider.BigQuery) {
      return null
    }
    const polyLineQuery = dedent`
    SELECT groupfield, ST_MAKELINE(ARRAY_AGG(geom)) geom
    FROM (
      SELECT ${params.groupfield} groupfield, ${params.sourcefield} geom
      FROM ${connection.quoteName(params.source as string)}
      ORDER BY ${params.sequencefield}
    )
    GROUP BY groupfield
  `
    if (params.buildmethod === 'Convex Hull') {
      return dedent`
        SELECT
          groupfield,
          CASE WHEN ST_NPOINTS(geom) <=1 THEN
              geom
            ELSE
              ST_CONVEXHULL(ST_MAKEPOLYGON(geom))
          END geom
          FROM (
            ${polyLineQuery}
          )
      `
    } else if (params.buildmethod === 'Sequence Polygon') {
      return dedent`
        SELECT
          groupfield,
          CASE WHEN ST_NPOINTS(geom) <=1 THEN
              geom
            ELSE
              ST_MAKEPOLYGON(geom)
          END geom
          FROM (
            ${polyLineQuery}
          )
      `
    } else {
      return polyLineQuery
    }
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery]
  }
}

export { PolyBuild }
